module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Authornote"
    }
  }, [_c('i', [_vm._v("Author’s Note")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/Prologue"
    }
  }, [_c('i', [_vm._v("Prologue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("I. First Lessons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("II. The Fledgling")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003"
    }
  }, [_vm._v("III. Baptism of Blood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV. New Skills")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V. The Jungles Again")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI. The Student Who Spoke His Mind")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII. Return of the Tiger")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII. A Changed Man")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX. Dress Rehearsal")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X. A War Within a War")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI. Winning the War at Home")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII. Cape Gloucester")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII. Written in Blood")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV. Years of Peace")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV. War on a Shoestring")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI. MacArthur’s Triumph")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII. The Hordes of China")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVIII. End of a Nightmare")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIX. Are These Americans?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Epilogue")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Appendix",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/Acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-text"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("About the Author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19bc3a27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 72
// module chunks = 0